import { render } from "./ExportUserIdsDetail.vue?vue&type=template&id=b04649da&scoped=true"
import script from "./ExportUserIdsDetail.vue?vue&type=script&lang=js"
export * from "./ExportUserIdsDetail.vue?vue&type=script&lang=js"

import "./ExportUserIdsDetail.vue?vue&type=style&index=0&id=b04649da&scoped=true&lang=css"

import exportComponent from "/Users/sivasankarelango/Sivasankar/cx-portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b04649da"]])

export default __exports__